
import { ref, defineComponent, computed, watch, reactive, onMounted } from 'vue'
import { useStore } from 'vuex'
import { set, menuDetail } from '../request'
import { message } from 'ant-design-vue'
import MenuList from '@/modules/menu/components/MenuList.vue'
import { systemMenu } from '@/modules/menu/request'

export default defineComponent({
    components: {
        MenuList,
    },
    setup() {
        const store = useStore()
        const formRef = ref()
        const detail = computed(() => store.state.version.detail)
        let menus = ref([])
        // reactive
        interface Form {
            name: string
        }
        const form = reactive<Form>({
            name: '',
        })
        const init = () => {
            if (detail.value) {
                Object.assign(form, {
                    name: detail.value.name,
                })
            }
        }
        const loading = ref<boolean>(false)
        const afterClose = () => {
            store.commit('toggleVersionSetMenuState', false)
            store.commit('setVersionDetail', null)
        }
        /**
         * 获取菜单树
         */
        const fetchMenuTree = async () => {
            let res = await systemMenu({})
            menus.value = res.data
        }
        const fetchDetail = async () => {
            let res = await menuDetail({
                versionId: detail.value && detail.value.id,
            })
            let codes = res.data.menuCodes
            fillModuleCodes(codes)
        }

        /**
         * 获取所有选中的子模块
         */
        const getSelectMenuCodes = (): Array<string> => {
            let menuCodes: Array<string> = []
            function getModuleId(node: any) {
                if (node.checked) {
                    menuCodes.push(node.code)
                }
                if (node.children && node.children.length) {
                    node.children.forEach((item: any) => {
                        getModuleId(item)
                    })
                }
            }
            menus.value.forEach((module: any) => {
                getModuleId(module)
            })
            return menuCodes
        }

        // 回填module ids
        const fillModuleCodes = (codes: Array<string>) => {
            function setChecked(node: any) {
                if (codes.indexOf(node.code) > -1) {
                    node.checked = true
                }
                if (node.children && node.children.length) {
                    node.children.forEach((item: any) => {
                        setChecked(item)
                        // 子节点选中，就把父节点展开
                        if (codes.indexOf(item.code) > -1) {
                            node.expand = true
                        }
                    })
                }
            }
            menus.value.forEach((module: any) => {
                setChecked(module)
            })
        }
        const onSubmit = async () => {
            let params = {
                menuCodes: getSelectMenuCodes(),
            }
            if (detail.value) {
                Object.assign(params, {
                    versionId: detail.value.id,
                })
            }
            loading.value = true
            try {
                await set(params)
                loading.value = false
                message.success('保存成功')
                afterClose()
            } catch (e) {
                loading.value = false
            }
        }
        watch(detail, () => {
            init()
        })
        onMounted(async () => {
            loading.value = true
            try {
                await fetchMenuTree()
                await fetchDetail()
            } catch (e) {
                loading.value = false
            }
            loading.value = false
        })
        init()
        return {
            form,
            store,
            loading,
            onSubmit,
            afterClose,
            detail,
            menus,
            formRef,
        }
    },
})
